






















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    getAlertColorByPriority,
    getIndexFromList,
    existItemInList,
    tableSort
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Combobox,
    Breadcrums,
    PlusEyeButtons,
    CloseConfirmationModal
} from '../../core/components';
import Input from '../../core/components/Input.vue';
import Checkbox from '../../core/components/Checkbox.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import CreateFrame from './CreateFrame.vue';
import CreateSessionFrame from './CreateSessionFrame.vue';
import HexadecimalValue from './HexadecimalValue.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { NormsServices } from '../api/NormsServices';
import PreviewEcu from './PreviewEcu.vue';
import CreateProtocol from './CreateProtocol.vue';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import { getHexadecimalValue } from '../utils';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        CreateProtocol,
        PreviewEcu,
        Breadcrums,
        PlusEyeButtons,
        CreateSessionFrame,
        CreateFrame,
        CloseConfirmationModal,
        Input,
        SimpleTable,
        Checkbox,
        HexadecimalValue
    }
})
export default class CreateEcuDialog extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() previewEcuFromList: boolean;
    @Prop({ default: {} }) previewEcuFromListData: object;
    modifySessionFrameData: object = {};
    eventCreateSF: string = '';
    errorResponse: any = {};
    loadingPatchFin: boolean = false;
    loadingPatchInit: boolean = false;
    loadingPatchKeepAlive: boolean = false;
    loadingModifyProtocol: boolean = false;
    editSessionFrame: boolean = false;
    editingFrame: boolean = false;
    editingProtocol: boolean = false;
    previewPatchEcu: boolean = false;
    ecuIsActiveInFiles: number = 0;
    parentModal: any = '';
    pendingProtocols: boolean = false;
    pendingRequest: boolean | null = null;
    visibleModalCreateFrame: boolean = false;
    confirmPatch: boolean = true;
    visibleModalCreateSessionFrame: boolean = false;
    actionModalSessionFrame: string = '';
    visibleModalCreateProtocol: boolean = false;
    initializationsOptions: any = [];
    pendingProtocolInitializations: boolean = false;
    visibleModalCreateEcu: boolean = false;
    titleCreate: string = 'Creación de ECU';
    titlePreviewECU: string = 'Previsualizar ECU';
    titlePreviewPatch: string = 'Previsualizar Cambios';
    titleModify: string = 'Modificar ECU';
    step: number = 1;
    currentAction: string = '';
    excludedParams: any = [];
    protocolPatchData: object = {};
    parametersToRemove: object = {
        section: '',
        items: []
    };
    invertPolarityOptions: any = [
        {
            description: 'true',
            value: 'true'
        },
        {
            description: 'false',
            value: 'false'
        }
    ];
    patchPreviewData: object = {};
    ecuPreviewData: object = {};
    // ecuPostData: object = {};
    ecuPostData: object = {};

    //Definicion de la ecu
    privateDescription: string = '';
    publicDescription: string = '';
    ecurdaddr: number | string = '';
    ecuwraddr: number | string = '';
    dtcsInterpretationTypesOptions: any = [];

    //Asignar categorías
    categorySelected: object | any = null;
    categoryInAssignFrames: object | any = null;
    resetKeepAliveSelect: boolean = false;
    resetInitializationSelect: boolean = false;
    resetCategorySelect: boolean = false;
    resetFinalizationSelect: boolean = false;
    keepAliveSelected: object | any = null;
    invertPolaritySelected: any = null;
    listenOnlyModeSelected: any | null = null;
    dtcsInterpretationTypeSelected: any | null = null;
    initializationSelected: object | any = null;
    finalizationSelected: object | any = null;
    categoriesSelected: any = [];
    headersSelectedCategories: object = [
        {
            text: 'Categoría',
            align: 'left',
            value: 'category.description'
        },
        {
            text: 'Keepalive',
            align: 'left',
            value: 'keepalive.description'
        },
        {
            text: 'Initialization',
            align: 'left',
            value: 'initialization.description'
        },
        {
            text: 'Finalization',
            align: 'left',
            value: 'finalization.description'
        },
        {
            text: 'Alertas',
            align: 'left',
            value: 'alerts_db'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions_db'
        }
    ];
    categoriesOptions: any = [];
    framesTypes: any = [];
    itemsSelectedCategories: any = [];
    noAvailableObject: object = {
        id: -1,
        description: 'No available'
    };
    noAvailableOption: object = this.noAvailableObject;

    //Protocolo
    protocolOptions: any = [];
    protocolSelected: any = null;
    protocolTypeId: number | any = null;

    //AsignarFrames
    // framesList: any = [];
    pendingRequestAvailableFrames: boolean = false;
    framesSelected: any = [];
    headersFilteredFrames: object = [
        {
            text: 'Descripción',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions_db',
            width: '120'
        }
    ];
    searchFilteredFrames: string = '';
    itemsFilteredFrames: any = [];

    //Frames seleccionados
    framesAddedSelected: any = [];
    searchSelectedFrames: string = '';
    headersFrameAdded: object = [
        {
            text: 'Descripción',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Categoría',
            align: 'left',
            value: 'category_descripcion',
            width: '150px'
        },
        {
            text: 'Alertas',
            align: 'left',
            value: 'alerts_db',
            width: '150px'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions_db',
            width: '120'
        }
    ];
    itemsFramesAdded: any = [];

    //Asignar parámetros de frame
    //parámetros disponibles
    pendingRequestParamFromFramesSelected: boolean = false;
    availableParamsSelected: any = [];
    selectedAvailableParams: any = [];
    selectedAllParamsFromAllFrames: boolean = false;
    searchAvailableParams: string = '';
    headersAvailableParams: object = [
        {
            text: 'Parámetro',
            align: 'left',
            value: 'description'
        },
        {
            text: 'Slot',
            align: 'left',
            value: 'slot_description'
        },
        {
            text: 'Descripción privada',
            align: 'left',
            value: 'private_description'
        },
        {
            text: 'Starting Byte',
            align: 'center',
            value: 'starting_byte',
            width: '7%'
        },
        {
            text: 'Starting Bit',
            align: 'center',
            value: 'starting_bit_delimiter',
            width: '7%'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions_db',
            width: '120'
        }
    ];
    itemsAvailableParams: any = [];
    sessionFramesOptions: any = [this.noAvailableObject];
    framesSelectedInAssignParameters: any | null = null;
    pendingRequestUpdateAvailableParams: boolean = false;
    //parámetros seleccionados
    itemsAvailableSelectedParams: any = [];
    validParamsSelected: boolean = true;
    searchAvailableSelectedParams: string = '';
    headersAvailableSelectedParams: object = [
        {
            text: 'Parámetro',
            align: 'left',
            value: 'description',
            width: '24%'
        },
        {
            text: 'Slot',
            align: 'left',
            value: 'slot_description'
        },
        {
            text: 'Descripción privada',
            align: 'left',
            value: 'private_description',
            width: '20%'
        },

        {
            text: 'Min',
            align: 'left',
            value: 'min',
            width: '7%'
        },
        {
            text: 'Default',
            align: 'left',
            value: 'default',
            width: '7%'
        },
        {
            text: 'Max',
            align: 'left',
            value: 'max',
            width: '7%'
        },
        {
            text: 'Starting Byte',
            align: 'center',
            value: 'starting_byte',
            width: '7%'
        },
        {
            text: 'Starting Bit',
            align: 'center',
            value: 'starting_bit_delimiter',
            width: '7%'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions_db',
            width: '120'
        }
    ];

    frameToPatch: any = {};
    defaultAlert: object = {
        count: 0,
        messages: []
    };
    protocolTypes: any = [];
    breadcrumsItems: any = [];
    visibleCloseConfirmationModal: boolean = false;

    updateSelectedCategories(rows){
        this.categoriesSelected = rows;
    }
    updateSelectedFrames(rows){
        this.framesSelected = rows;
    }
    updateFramesAddedSelected(rows){
        this.framesAddedSelected = rows;
    }
    updateAvailableParamsSelected(rows){
        this.availableParamsSelected = rows;
    }
    updateSelectedAvailableParams(rows){
        this.selectedAvailableParams = rows;
    }

    get getBreadcrumsItems() {
        if (this.currentAction === 'create') {
            return [
                {
                    text: 'Listado de ECUs',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'back'
                },
                {
                    text: 'Crear ECU',
                    disabled: false,
                    href: '',
                    active: true,
                    action: null
                }
            ];
        } else if (this.currentAction === 'modify') {
            return [
                {
                    text: 'Listado de ECUs',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'back'
                },
                {
                    text: 'Previsualizar ECU',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'previewEcu'
                },
                {
                    text: 'Modificar ECU',
                    disabled: false,
                    href: '',
                    active: true,
                    action: null
                }
            ];
        } else if (this.currentAction === 'preview') {
            if (!this.previewEcuFromList) {
                return [
                    {
                        text: 'Listado de ECUs',
                        disabled: false,
                        href: '',
                        active: false,
                        action: 'back'
                    },
                    {
                        text: this.previewEcuFromList ? 'Modificar ECU' : 'Crear ECU',
                        disabled: false,
                        href: '',
                        active: false,
                        action: 'modifyEcu'
                    },
                    {
                        text: 'Previsualizar ECU',
                        disabled: false,
                        href: '',
                        active: true,
                        action: null
                    }
                ];
            } else {
                return [
                    {
                        text: 'Listado de ECUs',
                        disabled: false,
                        href: '',
                        active: false,
                        action: 'back'
                    },
                    {
                        text: 'Previsualizar ECU',
                        disabled: false,
                        href: '',
                        active: true,
                        action: null
                    }
                ];
            }
        } else if (this.currentAction === 'preview_patch') {
            return [
                {
                    text: 'Listado de ECUs',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'back'
                },
                {
                    text: 'Previsualizar ECU',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'previewEcu'
                },
                {
                    text: 'Modificar ECU',
                    disabled: false,
                    href: '',
                    active: false,
                    action: 'modifyEcu'
                },
                {
                    text: 'Confirmar Cambios',
                    disabled: false,
                    href: '',
                    active: true,
                    action: null
                }
            ];
        } else {
            return [];
        }
    }

    updateConfirmPatch(value){
        this.confirmPatch = value;
    }

    get getCategoriesOptions() {
        return this.categoriesOptions;
    }

    get getDtcsInterpretationTypesOptions() {
        if (this.dtcsInterpretationTypesOptions.length !== 0) {
            return this.dtcsInterpretationTypesOptions.sort(sortObjectByPropertyName('value'));
        } else {
            return this.dtcsInterpretationTypesOptions;
        }
    }

    get disableSessionFrameForScannerProt() {
        if (this.protocolSelected == null || this.categorySelected == null) {
            return true;
        } else {
            return this.protocolSelected['name'] === 'Scanner' ? true : false;
        }
    }

    get disableCreateFrame() {
        if (this.protocolSelected == null || this.protocolSelected['name'] === 'Scanner') {
            return true;
        } else {
            return false;
        }
    }

    disableEditSessionFrame(value) {
        if (value == null || value['id'] == -1) {
            return true;
        } else {
            return false;
        }
    }

    createFrame() {
        this.editingFrame = false;
        this.visibilityModalCreateFrame(true);
    }

    loadPatchData(data) {
        //Assign data Ecu definition
        this.privateDescription = data['ecu_definition']['description'];
        this.publicDescription = data['ecu_definition']['public_description'];
        this.titleModify = 'Modificar ECU - <b>' + this.privateDescription + '</b>';
        this.ecurdaddr = data['ecu_definition']['ecu_read_address'];
        this.ecuwraddr = data['ecu_definition']['ecu_write_address'];
        this.updateFrameSelected(null);
        this.updateCategorySelected(null);
        this.resetSessionFramesSelectors();
        this.updateInvertPolarity(this.getDefinitionValueFromBoolean(data['ecu_definition']['invert_polarity']));
        this.updateListenOnlyMode(this.getDefinitionValueFromBoolean(data['ecu_definition']['listen_only_mode']));
        let dtcsInterpretationTypeIndex = this.getIndexId(this.dtcsInterpretationTypesOptions, data['ecu_definition']['dtc_interpretation_type'])
        let indexProtocolType = this.getIndexId(this.protocolTypes, data['protocol']['type']) 
        let protocolName = this.protocolTypes[indexProtocolType]['value'];

        if (this.protocolOptions.length !== 0) {
            this.protocolOptions = this.protocolOptions.filter(item => item['name'] === protocolName);
            let protocolIndexInList = this.getIndexId(this.protocolOptions, data['protocol']['id'])
            this.protocolSelected = this.protocolOptions[protocolIndexInList];
        }

        this.updateDtcsInterpretationTypes(this.dtcsInterpretationTypesOptions[dtcsInterpretationTypeIndex]);

        //Assign frames
        let responseFrames = data['frames'];
        let parametersList: any = [];
        for (let b = 0; b < responseFrames.length; b++) {
            let frame = responseFrames[b];
            let categoryDescription = this.categoriesOptions.filter(item => item['id'] == frame['category']);
            if (this.ecuIsCurrentlyActive) {
                this.$set(frame, 'isSelectable', false);
            }
            this.$set(frame, 'description', frame['description']);
            this.$set(frame, 'protocol_type', this.protocolSelected['name']);
            this.$set(frame, 'category_descripcion', categoryDescription[0]['description']);
            this.$set(frame, 'alerts', this.defaultAlert);

            //Assign parameters
            for (let c = 0; c < frame['parameters'].length; c++) {
                let param = frame['parameters'][c];
                if (this.ecuIsCurrentlyActive && !frame['isSelectable']) {
                    this.$set(param, 'isSelectable', false);
                }
                this.$set(param, 'description', param['description']);
                this.$set(param, 'category_descripcion', categoryDescription[0]['description']);
                this.$set(param, 'frame_descripcion', frame['description']);
                this.$set(param, 'frame_id', frame['id']);
                parametersList.push(param);
            }
        }
        this.itemsAvailableSelectedParams = parametersList;
        this.itemsFramesAdded = responseFrames;

        //Assign categories
        let responseCategories = data['categories'];
        for (let i = 0; i < responseCategories.length; i++) {
            let category = responseCategories[i];
            let categoryDescription = this.categoriesOptions.filter(item => item['id'] == category['category_id']);

            if (this.checkIfCategoryHasAnyFrameAssigned(category)) {
                this.$set(category, 'isSelectable', false);
            } else {
                this.$set(category, 'isSelectable', true);
            }

            this.$set(category, 'category', {
                id: category['category_id'],
                description: categoryDescription[0]['description']
            });
            this.$set(category, 'category_id', categoryDescription[0]['id']);

            if (this.protocolSelected) {
                this.$set(category, 'protocol_type', this.protocolSelected['name']);
            }
            this.$set(category, 'alerts', this.defaultAlert);
        }

        this.itemsSelectedCategories = responseCategories;
    }

    getDefinitionValueFromBoolean(value) {
        return {
            description: value.toString(),
            value: value.toString()
        };
    }

    @Watch('$_getNormsProperties', {immediate: true, deep: true})
    onNormsChange(){
        this.protocolTypes = this.convertDictionaryToList(this.$_getNormsProperties['all_protocols']);
        this.dtcsInterpretationTypesOptions = this.convertDictionaryToList(
            this.$_getNormsProperties['ecu_dtc_interpretation_types']
        );
        this.categoriesOptions = this.getDataFromNormsProperties('all_categories_flag');
        this.framesTypes = this.convertDictionaryToList(this.getDataFromNormsProperties('all_frame_types'));
    }

    //methods
    mounted() {
        this.handleListenKey(true);
        this.getProtocols();
        this.updateBreadcrums();
        // this.parentModal = this.$ref.modalCreateEcu;
        this.visibleModalCreateEcu = this.visible;
        this.protocolTypes = this.convertDictionaryToList(this.$_getNormsProperties['all_protocols']);
        this.dtcsInterpretationTypesOptions = this.convertDictionaryToList(
            this.$_getNormsProperties['ecu_dtc_interpretation_types']
        );
        this.categoriesOptions = this.getDataFromNormsProperties('all_categories_flag');
        this.framesTypes = this.convertDictionaryToList(this.getDataFromNormsProperties('all_frame_types'));
        if (this.previewEcuFromList) {
            this.previewFile();
        }

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_CLOSE_CHILDREN_COMPONENTS, () => {
            this.closeModal();
        });

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_PREVIEW_ECU, () => {
            this.previewFile();
        });

        EventBus.$on(TypeEventBus.NORMS_ECU_DIALOG_MODIFY_ECU, () => {
            this.prevStep();
        });
    }

    updatePrivateDescription(value){
        this.privateDescription = value
    }
    updatePublicDescription(value){
        this.publicDescription = value
    }
    updateEcuraddr(value){
        this.ecurdaddr = value
    }
    updateEcuwaddr(value){
        this.ecuwraddr = value
    }
    updateSearchFilteredFrames(value){
        this.searchFilteredFrames = value
    }
    updateSearchSelectedFrames(value){
        this.searchSelectedFrames = value
    }
    updateSearchAvailableParams(value){
        this.searchAvailableParams = value
    }
    updateSearchAvailableSelParams(value){
        this.searchAvailableSelectedParams = value
    }

    get mainModal(): HTMLFormElement {
        return this.$refs.modalCreateEcu as HTMLFormElement;
    }

    formatPreviewData(previewData) {
        let activeFiles =
            previewData['active_files'] !== undefined ? this.formatActiveFiles(previewData['active_files']) : [];
        let privateDescription = previewData['ecu_definition']['description'];
        let public_description = previewData['ecu_definition']['public_description'];
        let ecurdaddr =
            previewData['ecu_definition']['ecu_read_address'] +
            ' (' +
            getHexadecimalValue(previewData['ecu_definition']['ecu_read_address']) +
            ')';
        let ecuwraddr =
            previewData['ecu_definition']['ecu_write_address'] +
            ' (' +
            getHexadecimalValue(previewData['ecu_definition']['ecu_write_address']) +
            ')';
        let invertpolarity = previewData['ecu_definition']['invert_polarity'];
        let dtcsInterpretationTypeIndex = this.getIndexId(this.dtcsInterpretationTypesOptions, previewData['ecu_definition']['dtc_interpretation_type'])
        let dtcsinterpretationtype;
        if (dtcsInterpretationTypeIndex !== -1) {
            dtcsinterpretationtype = this.dtcsInterpretationTypesOptions[dtcsInterpretationTypeIndex]['value'];
        } else {
            dtcsinterpretationtype = previewData['ecu_definition']['dtc_interpretation_type'];
        }
        let listenonlymode = previewData['ecu_definition']['listen_only_mode'];
        let protocol = this.getProtocolPreviewData(previewData);
        let categories = this.formatCategories(previewData['categories']);
        let frames = this.formatFrames(previewData['frames']);

        let data = [
            {
                key: 'active_files',
                values: activeFiles,
                hidden: !this.previewEcuFromList || activeFiles.length == 0 ? true : false,
                noDataText: 'Esta ECU no está presente en ningún archivo'
            },
            {
                key: 'ecu_definition',
                values: [
                    '<b>private_description: </b>' + privateDescription,
                    '<b>public_description: </b>' + public_description,
                    '<b>ecurdaddr: </b>' + ecurdaddr,
                    '<b>ecuwraddr: </b>' + ecuwraddr,
                    '<b>invertpolarity: </b>' + invertpolarity,
                    '<b>dtcsinterpretationtype: </b>' + dtcsinterpretationtype,
                    '<b>listenonlymode: </b>' + listenonlymode,
                    '<b>protocol: </b>' + protocol
                ],
                hidden: false,
                noDataText: 'No hay datos para mostrar'
            },
            {
                key: 'categories',
                values: categories,
                hidden: false,
                noDataText: 'No hay categorías para mostrar'
            },
            {
                key: 'frames',
                values: frames,
                hidden: false,
                noDataText: 'No hay frames para mostrar'
            }
        ];
        return data;
    }

    getProtocolPreviewData(previewData) {
        if (previewData['ecu_definition']['protocol'] !== undefined) {
            if (typeof previewData['ecu_definition']['protocol'] !== 'string') {
                return (
                    this.getProtocolType(previewData['ecu_definition']['protocol']['type']) +
                    ' - ' +
                    previewData['ecu_definition']['protocol']['description']
                );
            } else {
                return previewData['ecu_definition']['protocol'];
            }
        } else {
            if (previewData['protocol'] !== undefined) {
                if (typeof previewData['protocol'] !== 'string') {
                    return (
                        this.getProtocolType(previewData['protocol']['type']) +
                        ' - ' +
                        previewData['protocol']['description']
                    );
                } else {
                    return previewData['protocol'];
                }
            }
        }
    }

    formatFrames(frames) {
        let framesList: any = [];
        for (let i = 0; i < frames.length; i++) {
            let frameType = this.getFrameType(frames[i]['type']);
            let category =
                frames[i]['category'] !== undefined
                    ? this.getCategoryDescription(frames[i]['category'])
                    : frames[i]['category_descripcion'];
            let frameDescription = frames[i]['description'];
            framesList.push({
                description:
                    '<b>descripción: </b>' +
                    frameDescription +
                    ', ' +
                    '<b>categoría: </b>' +
                    category +
                    ', ' +
                    '<b>tipo: </b>' +
                    frameType,
                parameters: this.getParametersPreview(frames[i]['parameters'], frameType, category)
            });
        }
        return framesList;
    }

    getParametersPreview(parameters, frameType, category) {
        let parametersList: any = [];

        for (let i = 0; i < parameters.length; i++) {
            let paramDescription = parameters[i]['description'];
            parametersList.push(
                '<b>description:</b> ' +
                    paramDescription +
                    ', ' +
                    '<b>frame: </b>' +
                    frameType +
                    ', ' +
                    '<b>category: </b>' +
                    category +
                    ', ' +
                    '<b>min: </b>' +
                    parameters[i]['min'] +
                    ', ' +
                    '<b>default: </b>' +
                    parameters[i]['default'] +
                    ', ' +
                    '<b>max: </b>' +
                    parameters[i]['max']
            );
        }

        return parametersList;
    }

    getFrameType(type) {
        let allFramesTypes = this.convertDictionaryToList(this.getDataFromNormsProperties('all_frame_types'));
        let indexMatchedFrame = this.getIndexId(allFramesTypes, type) 
        return allFramesTypes[indexMatchedFrame]['value'];
    }

    formatCategories(categories) {
        let array: any = [];

        for (let i = 0; i < categories.length; i++) {
            let categoryId =
                categories[i]['category_id'] !== undefined
                    ? Number(categories[i]['category_id'])
                    : Number(categories[i]['category']['id']);
            array.push(
                '<b>nombre: </b>' +
                    this.getCategoryDescription(categoryId) +
                    ', ' +
                    '<b>keepalive: </b>' +
                    categories[i]['keepalive']['description'] +
                    ', ' +
                    '<b>initialization: </b>' +
                    categories[i]['initialization']['description'] +
                    ', ' +
                    '<b>finalization: </b>' +
                    categories[i]['finalization']['description']
            );
        }
        return array;
    }

    formatActiveFiles(activeFiles) {
        let array: any = [];
        for (let i = 0; i < activeFiles.length; i++) {
            array.push(
                '<b>id: </b>' + activeFiles[i]['id'] + ', ' + '<b>description: </b>' + activeFiles[i]['description']
            );
        }
        return array;
    }

    getProtocolType(type) {
        let indexMatchedProtocol = this.getIndexId(this.protocolTypes, type);
        return this.protocolTypes[indexMatchedProtocol]['value'];
    }

    getCategoryDescription(type) {
        let allCategories = this.categoriesOptions;
        let indexMatchedCategory = this.getIndexId(allCategories, type)
        return allCategories[indexMatchedCategory]['description'];
    }

    getProtocols() {
        let self = this;
        this.pendingProtocols = true;
        NormsServices.getProtocols(Axios.CancelToken.source())
            .then(response => {
                let protocols: any = [];
                for (let i = 0; i < response['protocols'].length; i++) {
                    let item = response['protocols'][i];
                    protocols.push({
                        id: item['id'],
                        description: item['description'],
                        name: item['name'],
                        namedescription: item['name'] + ' - ' + item['description']
                    });
                }
                self.protocolOptions = protocols.sort(sortObjectByPropertyName('namedescription'));
                self.pendingProtocols = false;

                //load data to create new ecu from other file
                //after initializing the protocols
                if (!self.previewEcuFromList) {
                    if (Object.keys(self.previewEcuFromListData).length > 0) {
                        self.scrollToTopOfModal();
                        self.prevStep();
                        self.loadPatchData(self.previewEcuFromListData);
                    }
                }
            })
            .catch(error => {
                self.pendingProtocols = false;
                self.handleErrorAction(error, 'No se pudieron obtener los protocolos');
            });
    }

    checkIfAddedCategoriesAreInCurrentCategories() {
        for (let i = 0; i < this.getItemsCategoriesAdded.length; i++) {
            let category = this.getItemsCategoriesAdded[i];
            if (this.protocolSelected !== null) {
                let indexKeepAliveInSessionFrames = this.getIndexId(this.sessionFramesOptions, category['keepalive']['id']);
                let indexInitializationInSessionFrames = this.getIndexId(this.sessionFramesOptions, category['initialization']['id'])
                let indexFinalizationInSessionFrames = this.getIndexId(this.sessionFramesOptions, category['finalization']['id']);
                if (
                    indexKeepAliveInSessionFrames == -1 ||
                    indexInitializationInSessionFrames == -1 ||
                    indexFinalizationInSessionFrames == -1
                ) {
                    this.$set(category, 'alerts', {
                        count: 1,
                        messages: ['Estos session frames son del tipo: ' + category['protocol_type']]
                    });
                }
                if (
                    indexKeepAliveInSessionFrames !== -1 &&
                    indexInitializationInSessionFrames !== -1 &&
                    indexFinalizationInSessionFrames !== -1
                ) {
                    this.$set(category, 'alerts', {
                        count: 0,
                        messages: []
                    });
                }
            } else {
                this.$set(category, 'alerts', {
                    count: 1,
                    messages: ['Estos session frames están asociados al protocolo: ' + category['protocol_type']]
                });
            }
        }
    }

    @Watch('getItemsFramesAdded')
    watchGetItemsFramesAdded(items) {
        for (let i = 0; i < this.framesAddedSelected.length; i++) {
            let item = this.framesAddedSelected[i];

            if (item['isSelectable'] == false) {
                this.$set(this.framesAddedSelected, 'isSelectable', false);
                this.removeIndexFromArray(this.framesAddedSelected, i);
            }
        }
    }

    @Watch('protocolSelected')
    watchProtocol(value) {
        if (value !== null) {
            this.getSessionFrames();
            if (this.categoryInAssignFrames !== null) {
                this.getFramesByCategoryAndProtocol(null);
            }
            if (value && value['id'] !== 11) {
                this.updateInvertPolarity({
                    description: 'false',
                    value: 'false'
                });
            }
        } else {
            this.updateCategorySelected(null);
            this.checkIfAddedCategoriesAreInCurrentCategories();
        }
        this.checkIfAssignedFramesAreInCurrentProtocol();
    }

    @Watch('step')
    watchStep() {
        this.updateBreadcrums();
    }

    updateBreadcrums() {
        this.currentAction = '';

        setTimeout(() => {
            if (this.step == 1) {
                if (!this.previewEcuFromList) {
                    this.currentAction = 'create';
                } else {
                    this.currentAction = 'modify';
                }
            } else {
                if (this.previewPatchEcu) {
                    this.currentAction = 'preview_patch';
                } else {
                    this.currentAction = 'preview';
                }
            }
        }, 100);
    }

    checkIfAssignedFramesAreInCurrentProtocol() {
        for (let i = 0; i < this.getItemsFramesAdded.length; i++) {
            let frame = this.getItemsFramesAdded[i];
            let protocolSelected = this.protocolSelected !== null ? this.protocolSelected['name'] : null;
            if (protocolSelected !== null) {
                if (frame['protocol_type'] !== protocolSelected) {
                    this.$set(frame, 'alerts', {
                        count: 1,
                        messages: ['Este frame está asociado al protocolo: ' + frame['protocol_type']]
                    });
                } else {
                    this.$set(frame, 'alerts', {
                        count: 0,
                        messages: []
                    });
                }
            } else {
                this.$set(frame, 'alerts', {
                    count: 1,
                    messages: ['Este frame está asociado al protocolo: ' + frame['protocol_type']]
                });
            }
        }
    }

    getFramesByCategoryAndProtocol(frameToAdd) {
        let self = this;
        if (this.categoryInAssignFrames !== null) {
            this.pendingRequestAvailableFrames = true;
            let protocol_id = this.protocolTypeId;
            let category_id = Number(this.categoryInAssignFrames['id']);
            NormsServices.getFramesByCategoryAndProtocol(protocol_id, category_id)
                .then(response => {
                    let items: any = [];
                    for (let i = 0; i < response['frames'].length; i++) {
                        let item = response['frames'][i];
                        if (!this.checkIfIDExistsInArray(this.itemsFramesAdded, item['id'])) {
                            this.$set(item, 'added', false);
                        } else {
                            this.$set(item, 'added', true);
                            if (this.ecuIsCurrentlyActive) {
                                this.$set(item, 'isSelectable', false);
                            }
                        }
                        items.push(item);
                    }
                    self.itemsFilteredFrames = items;
                    let idNewFrameToAdd = self.getIndexId(self.itemsFilteredFrames, frameToAdd['id']);
                    if (frameToAdd !== null || frameToAdd !== undefined) {
                        self.addOrRemoveSelectedFrames(this.itemsFilteredFrames[idNewFrameToAdd]);
                        self.$set(this.itemsFilteredFrames[idNewFrameToAdd], 'added', true);
                    }
                    self.pendingRequestAvailableFrames = false;
                })
                .catch(error => {
                    this.pendingRequestAvailableFrames = false;
                    self.handleErrorAction(error, 'No se pudieron obtener las frames');
                });
            this.getProtocolInitializations(protocol_id);
        }
    }

    getProtocolInitializations(protocolId) {
        let self = this;
        this.pendingProtocolInitializations = true;
        NormsServices.getProtocolsInitializations(protocolId)
            .then(response => {
                self.initializationsOptions = response['initializations'];
                this.pendingProtocolInitializations = false;
            })
            .catch(error => {
                // console.log("error", error);
                this.pendingProtocolInitializations = false;
                self.handleErrorAction(error, 'No se pudieron obtener las inicializaciones de los protocolos');
            });
    }

    resetSessionFramesSelectors() {
        this.updateKeepAliveSelected(null);
        this.resetKeepAliveSelect = true;
        this.updateInitializationSelected(null);
        this.resetInitializationSelect = true;
        this.updateFinalizationSelected(null);
        this.resetFinalizationSelect = true;
        // this.sessionFramesOptions = [this.noAvailableObject]
    }

    getSessionFrames() {
        if (this.protocolSelected) {
            let indexMatchedProtocol = getIndexFromList(this.protocolTypes, 'value', this.protocolSelected['name']);
            this.protocolTypeId = Number(this.protocolTypes[indexMatchedProtocol]['id']);
            let self = this;
            NormsServices.getSessionFramesList(this.protocolTypeId)
                .then(response => {
                    this.resetSessionFramesSelectors();
                    let sessionFramesList = response['session_frames'];
                    this.sessionFramesOptions = sessionFramesList;
                    this.checkIfAddedCategoriesAreInCurrentCategories();
                })
                .catch(error => {
                    self.handleErrorAction(error, 'No se pudieron obtener las session frames');
                });
        } else {
            this.protocolTypeId = null;
            this.sessionFramesOptions = [this.noAvailableObject];
        }
    }

    convertDictionaryToList(obj) {
        let items: any = [];
        for (let i = 0; i < Object.keys(obj).length; i++) {
            items.push({
                id: Object.keys(obj)[i],
                value: Object.values(obj)[i]
            });
        }
        items.sort(sortObjectByPropertyName('value'));
        return items;
    }

    customItemClass(item) {
        return 'truncate-row';
    }

    customItemFrameClass(item) {
        if (this.checkIfFrameHasAnyParamAssigned(item)) {
            return 'truncate-row';
        } else {
            return 'truncate-row';
        }
    }

    closeModal() {
        this.$emit('close-modal', false);
        this.previewPatchEcu = false;
        this.ecuPreviewData = {};
        this.ecuPostData = {};
        this.step = 1;
        this.handleListenKey(false);
        this.visibilityCloseConfirmationModal(false);
    }

    visibilityModalCreateProtocol(value) {
        this.visibleModalCreateProtocol = value;
    }

    handleListenKey(value: boolean) {
        if (value) {
            this.$_disableListenkey();
        } else {
            this.$_enableListenkey();
        }
    }

    searchedParamsRowBackground(item) {
        return item.added ? 'truncate-row table-row-green' : 'truncate-row table-row-white';
    }

    getDataFromNormsProperties(option) {
        return this.$_getNormsProperties[option];
    }

    get getActionButton() {
        if (this.step == 1) {
            return 'Previsualizar ECU';
        } else {
            return 'Generar ECU';
        }
    }

    getParamsByIds(ids) {
        let paramsDescriptions: any = [];

        for (let index = 0; index < this.ecuPostData['frames'].length; index++) {
            const frame = this.ecuPostData['frames'][index];
            let params = frame['parameters'];
            for (let idx = 0; idx < params.length; idx++) {
                const param = params[idx];

                for (let c = 0; c < ids.length; c++) {
                    const id = ids[c];
                    if (id == param['id']) {
                        paramsDescriptions.push({
                            id: param['id'],
                            description: param['description']
                        });
                    }
                }
            }
        }

        return paramsDescriptions;
    }

    getParamsByVariableId(ids) {
        let paramsDescriptions: any = [];

        for (let index = 0; index < this.ecuPostData['frames'].length; index++) {
            const frame = this.ecuPostData['frames'][index];
            let params = frame['parameters'];
            for (let idx = 0; idx < params.length; idx++) {
                const param = params[idx];

                for (let c = 0; c < ids.length; c++) {
                    const id = ids[c];
                    if (id == param['variable_id']) {
                        paramsDescriptions.push({
                            id: param['variable_id'],
                            description: param['description']
                        });
                    }
                }
            }
        }

        return paramsDescriptions;
    }

    getExcludedParamsById(ids) {
        let paramsDescriptions: any = [];
        let params = this.excludedParams;
        for (let idx = 0; idx < params.length; idx++) {
            const param = params[idx];

            for (let c = 0; c < ids.length; c++) {
                const id = ids[c];
                if (id == param['variable_id']) {
                    paramsDescriptions.push({
                        id: param['variable_id'],
                        description: param['description']
                    });
                }
            }
        }

        return paramsDescriptions;
    }

    getParamsLength() {
        for (let index = 0; index < this.ecuPostData['frames'].length; index++) {
            const frame = this.ecuPostData['frames'][index];
            let params = frame['parameters'];
            return params.length;
        }
    }

    getFramesByIds(ids) {
        let paramsDescriptions: any = [];

        for (let index = 0; index < this.ecuPostData['frames'].length; index++) {
            const frame = this.ecuPostData['frames'][index];
            if (ids.indexOf(frame['id']) !== -1) {
                paramsDescriptions.push({
                    id: frame['id'],
                    description: frame['description']
                });
            }
        }

        return paramsDescriptions;
    }

    get getProtocolOptions() {
        return this.protocolOptions;
    }

    get enableSessionFrames() {
        if (this.categorySelected !== null) {
            return false;
        } else {
            return true;
        }
    }

    get enableModifyButton() {
        if (this.step == 1) {
            if (this.enablePreviewButton) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    }

    //Asignar categorías
    addCategoryToSelectedOnes(newCat) {
        let itemToAdd = {};
        let catId;
        if (newCat == null) {
            catId = Number(this.categorySelected['id']);
            itemToAdd = {
                id: Number(this.categorySelected['id']),
                protocol_type: this.protocolSelected['name'],
                category: this.categorySelected,
                keepalive: this.keepAliveSelected ? this.keepAliveSelected : this.noAvailableOption,
                initialization:
                    this.initializationSelected !== null ? this.initializationSelected : this.noAvailableOption,
                finalization: this.finalizationSelected ? this.finalizationSelected : this.noAvailableOption,
                alerts: this.defaultAlert
            };
        } else {
            catId = Number(newCat['id']);
            itemToAdd = newCat;
        }

        let indexCategoryInSelectedOnes = this.itemsSelectedCategories.findIndex(
            item => Number(item['category']['id']) === catId
        );
        if (indexCategoryInSelectedOnes == -1) {
            this.$set(itemToAdd, 'new_item', true);
            this.$set(itemToAdd, 'isSelectable', true);
            this.itemsSelectedCategories.push(itemToAdd);
        } else {
            let categoryToUpdate = this.itemsSelectedCategories[indexCategoryInSelectedOnes];
            this.$set(categoryToUpdate, 'keepalive', itemToAdd['keepalive']);
            this.$set(categoryToUpdate, 'initialization', itemToAdd['initialization']);
            this.$set(categoryToUpdate, 'finalization', itemToAdd['finalization']);
            this.$_showEmptyLastReport('Se actualizó la categoría: ' + this.categorySelected['description']);
        }
        this.resetSessionFramesSelectors();
    }

    addFrameToSelectedOnes() {
        for (let b = 0; b < this.framesSelected.length; b++) {
            let frameSelected = this.framesSelected[b];
            if (!this.checkIfIDExistsInArray(this.itemsFramesAdded, frameSelected['id'])) {
                this.itemsFramesAdded.push({
                    alerts: this.defaultAlert,
                    protocol_type: this.protocolSelected['name'],
                    description: frameSelected['description'],
                    id: frameSelected['id'],
                    category_descripcion: frameSelected['category_descripcion'],
                    type: frameSelected['type'],
                    parameters: []
                });
                this.$set(this.framesSelected[b], 'added', true);
            }
        }
        this.framesSelected = [];
    }

    removeFrameFromSelectedOnes() {
        for (let b = 0; b < this.getFramesAddedSelected.length; b++) {
            let frameToExclude = this.getFramesAddedSelected[b];

            if (!this.checkIfFrameHasAnyParamAssigned(frameToExclude)) {
                let indexFrameInFrameList = this.getIndexId(this.itemsFilteredFrames, frameToExclude['id']);
                let indexFrameInSelectedOnes = this.getIndexId(this.itemsFramesAdded, frameToExclude['id'])
                if (indexFrameInSelectedOnes !== -1) {
                    this.removeIndexFromArray(this.itemsFramesAdded, indexFrameInSelectedOnes);
                }

                if (indexFrameInFrameList !== -1) {
                    this.$set(this.itemsFilteredFrames[indexFrameInFrameList], 'added', false);
                }
            }
        }
        this.framesSelected = [];
        this.framesAddedSelected = [];
    }

    removeIndexFromArray(arr, index) {
        arr.splice(index, 1);
    }

    checkIfIDExistsInArray(arr, id) {
        if (arr.find(a => a.id === id)) {
            return true;
        } else {
            return false;
        }
    }

    updateProtocol(newProtocol) {
        let indexIdToPatch = this.getIndexId(this.protocolOptions, newProtocol['id']);
        this.$set(this.protocolOptions[indexIdToPatch], 'description', newProtocol['description']);
        this.$set(this.protocolOptions[indexIdToPatch], 'id', newProtocol['id']);
        this.$set(this.protocolOptions[indexIdToPatch], 'name', newProtocol['name']);
        let nameDescription = newProtocol['name'] + ' - ' + newProtocol['description'];
        this.$set(this.protocolOptions[indexIdToPatch], 'namedescription', nameDescription);
        this.protocolSelected = this.protocolOptions[indexIdToPatch];
    }

    getIndexId(list, id){
        return getIndexFromList(list, 'id', id);
    }

    updateSessionFrame(newSessionFrame) {
        let newSF = {
            description: newSessionFrame['description'],
            id: newSessionFrame['id']
        };
        let indexIdToPatch = this.getIndexId(this.sessionFramesOptions, newSF['id']);
        this.$set(this.sessionFramesOptions[indexIdToPatch], 'description', newSF['description']);
        this.$set(this.sessionFramesOptions[indexIdToPatch], 'id', newSF['id']);
        if (this.eventCreateSF === 'keep_alive') {
            this.updateKeepAliveSelected(this.sessionFramesOptions[indexIdToPatch]);
        } else if (this.eventCreateSF === 'init') {
            this.updateInitializationSelected(this.sessionFramesOptions[indexIdToPatch]);
        } else if (this.eventCreateSF === 'fin') {
            this.updateFinalizationSelected(this.sessionFramesOptions[indexIdToPatch]);
        }
    }

    updateFrame(newFrame, removedParams) {
        let indexFrameInSelectedFrames = this.getIndexId(this.itemsFramesAdded, newFrame['id']);
        let indexCat = this.getIndexId(this.categoriesOptions, newFrame['category_id'])

        let patchParameters = newFrame['parameter_list'];

        if (indexFrameInSelectedFrames !== -1) {
            //si el frame está seleccionado, actualizo los datos
            this.$set(
                this.itemsFramesAdded[indexFrameInSelectedFrames],
                'category_descripcion',
                this.categoriesOptions[indexCat]['description']
            );
            this.$set(this.itemsFramesAdded[indexFrameInSelectedFrames], 'category_id', newFrame['category_id']);
            this.$set(this.itemsFramesAdded[indexFrameInSelectedFrames], 'description', newFrame['description']);

            //agrego la categoría si no está dentro de las seleccionadas
            let indexCatInSelectedOnes = this.getIndexId(this.itemsSelectedCategories, newFrame['category_id']);
            if (indexCatInSelectedOnes == -1) {
                let categoryToAdd = this.getIndexId(this.categoriesOptions, newFrame['category_id']) 
                this.addCategoryToSelectedOnes({
                    id: newFrame['category_id'],
                    protocol_type: this.protocolSelected['name'],
                    category: this.categoriesOptions[categoryToAdd],
                    keepalive: this.noAvailableObject,
                    initialization: this.noAvailableObject,
                    finalization: this.noAvailableObject,
                    alerts: this.defaultAlert
                });
            }

            this.getParametersBySelectedFrame();

            //actualizo los frames disponibles
            this.getFramesByCategoryAndProtocol(null);
            for (let a = 0; a < this.itemsAvailableParams.length; a++) {
                let availableParam = this.itemsAvailableParams[a];
                if (availableParam['frame_id'] == newFrame['id']) {
                    //actualizo el frame en los param disponibles
                    this.$set(availableParam, 'frame_descripcion', newFrame['description']);
                    this.$set(availableParam, 'category_id', newFrame['category_id']);
                    this.$set(availableParam, 'category_descripcion', this.categoriesOptions[indexCat]['description']);

                    let indexParamInParamsResponse = this.getIndexId(patchParameters, availableParam['id']) 
                    if (indexParamInParamsResponse !== -1) {
                        this.$set(
                            availableParam,
                            'description',
                            patchParameters[indexParamInParamsResponse]['description']
                        );
                        this.$set(availableParam, 'min', patchParameters[indexParamInParamsResponse]['valor_minimo']);
                        this.$set(availableParam, 'max', patchParameters[indexParamInParamsResponse]['valor_maximo']);
                        this.$set(availableParam, 'frame_id', patchParameters[indexParamInParamsResponse]['frame']);
                    } else {
                        this.getParametersBySelectedFrame();
                    }
                }
            }

            for (let b = 0; b < this.itemsAvailableSelectedParams.length; b++) {
                let selectedParam = this.itemsAvailableSelectedParams[b];
                //actualizo el frame en los param seleccionados
                if (selectedParam['frame_id'] == newFrame['id']) {
                    this.$set(selectedParam, 'frame_descripcion', newFrame['description']);
                    this.$set(selectedParam, 'category_id', newFrame['category_id']);
                    this.$set(selectedParam, 'category_descripcion', this.categoriesOptions[indexCat]['description']);
                }

                for (let c = 0; c < patchParameters.length; c++) {
                    let param = patchParameters[c];
                    if (param['id'] == selectedParam['id']) {
                        this.$set(selectedParam, 'description', param['description']);
                        this.$set(selectedParam, 'min', param['valor_minimo']);
                        this.$set(selectedParam, 'max', param['valor_maximo']);
                        this.$set(selectedParam, 'frame_id', param['frame']);
                    }
                }
            }

            for (let d = 0; d < removedParams.length; d++) {
                let paramToExclude = removedParams[d];

                let indexParamInSelectedOnes = this.getIndexId(this.itemsAvailableSelectedParams, paramToExclude['id']);

                if (indexParamInSelectedOnes !== -1) {
                    this.removeIndexFromArray(this.itemsAvailableSelectedParams, indexParamInSelectedOnes);
                }
            }
        }
    }

    removeCategoryFromSelectedOnes() {
        if (this.itemsSelectedCategories.length > 0) {
            let self = this;
            this.itemsSelectedCategories.filter(function(obj) {
                if (self.checkIfObjectExistsInArray(obj, self.itemsSelectedCategories)) {
                    let indexToRemove = self.itemsSelectedCategories
                        .map(function(item) {
                            return item;
                        })
                        .indexOf(obj);
                    self.itemsSelectedCategories.splice(indexToRemove, 1);
                }
            });
        }
    }

    checkIfObjectExistsInArray(obj, list) {
        let i;
        for (i = 0; i < list.length; i++) {
            if (list[i] === obj) {
                return true;
            } else {
                return false;
            }
        }
    }

    deleteParameters(section, items) {
        this.parametersToRemove['items'] = [];
        this.$set(this.parametersToRemove, 'section', section);
        this.$set(this.parametersToRemove, 'items', items);

        let itemsToDelete = this.parametersToRemove['items'];

        let self = this;
        if (this.parametersToRemove['section'] === 'categories_selected') {
            for (let i = 0; i < this.parametersToRemove['items'].length; i++) {
                let selectedParamToRemove = this.getIndexId(this.itemsSelectedCategories, this.parametersToRemove['items'][i]['id']);
                if (!this.checkIfCategoryHasAnyFrameAssigned(this.itemsSelectedCategories[selectedParamToRemove])) {
                    this.itemsSelectedCategories.splice(selectedParamToRemove, 1);
                }
            }
            this.categoriesSelected = [];
        } else if (this.parametersToRemove['section'] === 'frames_selected') {
            for (let i = 0; i < this.parametersToRemove['items'].length; i++) {
                let selectedParamToRemove = this.getIndexId(this.itemsFramesAdded, this.parametersToRemove['items'][i]['id']);
                let indexFrameInFrameList = this.getIndexId(this.itemsFilteredFrames, this.parametersToRemove['items'][i]['id']);
                this.removeIndexFromArray(this.itemsFramesAdded, selectedParamToRemove);
                if (indexFrameInFrameList !== -1) {
                    this.$set(this.itemsFilteredFrames[indexFrameInFrameList], 'added', false);
                }
            }
            this.framesAddedSelected = [];
        } else if (this.parametersToRemove['section'] === 'parameter_selected') {
            for (let i = 0; i < this.parametersToRemove['items'].length; i++) {
                let selectedParamToRemove = this.getIndexId(this.itemsAvailableSelectedParams, this.parametersToRemove['items'][i]['id']);
                let indexParamInAvailableParamList =this.getIndexId(this.itemsAvailableParams, this.parametersToRemove['items'][i]['id'])
                if (selectedParamToRemove !== -1) {
                    if (this.currentAction === 'modify' && !this.ecuIsCurrentlyActive) {
                        if (
                            !this.checkIfIDExistsInArray(
                                this.excludedParams,
                                this.itemsAvailableSelectedParams[selectedParamToRemove]['id']
                            )
                        ) {
                            this.excludedParams.push(this.itemsAvailableSelectedParams[selectedParamToRemove]);
                        }
                    }
                    this.$set(this.itemsAvailableSelectedParams[selectedParamToRemove], 'added', false);

                    this.removeIndexFromArray(this.itemsAvailableSelectedParams, selectedParamToRemove);
                }

                if (indexParamInAvailableParamList !== -1) {
                    this.$set(this.itemsAvailableParams[indexParamInAvailableParamList], 'added', false);
                }
            }
            this.selectedAvailableParams = [];
            // this.framesAddedSelected = [];
        }
    }

    updateCategorySelected(option) {
        this.categorySelected = option;
        this.resetCategorySelected(true);
        this.resetSessionFramesSelectors();
    }

    updateCategoryInAssignFrames(option, frameToAdd?) {
        this.categoryInAssignFrames = option;

        if (option !== null && this.protocolSelected == null) {
            this.$_showParameterError('Debe seleccionar un protocolo');
        } else {
            this.getFramesByCategoryAndProtocol(frameToAdd);
        }
    }

    updateInvertPolarity(option) {
        this.invertPolaritySelected = option;
    }

    updateDtcsInterpretationTypes(option) {
        this.dtcsInterpretationTypeSelected = option;
    }

    updateListenOnlyMode(option) {
        this.listenOnlyModeSelected = option;
    }

    updateKeepAliveSelected(option) {
        this.keepAliveSelected = option;
    }

    updateKeepAliveResetValue(value) {
        this.resetKeepAliveSelect = value;
    }
    updateInitializationResetValue(value) {
        this.resetInitializationSelect = value;
    }
    updateFinalizationResetValue(value) {
        this.resetFinalizationSelect = value;
    }

    updateInitializationSelected(option) {
        this.initializationSelected = option;
    }

    updateFinalizationSelected(option) {
        this.finalizationSelected = option;
    }

    resetCategorySelected(value) {
        this.resetCategorySelect = value;
    }

    updateProtocolSelected(option) {
        this.protocolSelected = option;
    }

    updateFrameSelected(option) {
        this.framesSelectedInAssignParameters = option;

        if (this.framesSelectedInAssignParameters !== null) {
            this.getParametersBySelectedFrame();
        }
    }

    selectedAllParamsFromAllFramesList() {
        this.pendingRequestParamFromFramesSelected = true;
        let selectedFrames = this.getSelectedFrames;
        let framesIds: any = [];
        for (let i = 0; i < selectedFrames.length; i++) {
            framesIds.push(selectedFrames[i]['id']);
        }
        let self = this;
        NormsServices.getParametersByFrameId(framesIds)
            .then(response => {
                //response['parameters']
                this.checkAndAssignAvailableSelectedParams(response['parameters']);
                this.pendingRequestParamFromFramesSelected = false;
            })
            .catch(error => {
                this.pendingRequestParamFromFramesSelected = false;
                self.handleErrorAction(error, 'No se pudieron obtener los parámetros');
            });
    }

    getParametersBySelectedFrame() {
        let id = this.framesSelectedInAssignParameters !== null ? this.framesSelectedInAssignParameters['id'] : null;
        let self = this;

        if (id !== null) {
            this.pendingRequestUpdateAvailableParams = true;
            NormsServices.getParametersByFrameId([id])
                .then(response => {
                    this.checkAndAssignAvailableParams(response['parameters'], id);
                    this.pendingRequestUpdateAvailableParams = false;
                })
                .catch(error => {
                    this.pendingRequestUpdateAvailableParams = false;
                    self.handleErrorAction(error, 'No se pudieron obtener los parámetros');
                });
        }
    }

    checkAndAssignAvailableParams(parameters, frameId) {
        let items: any = [];
        if (parameters.length !== 0) {
            for (let i = 0; i < parameters.length; i++) {
                let param = parameters[i];
                let indexParamInSelectedOnes = this.checkIfParamIdExistInSelectedParams(param['id']);
                let paramExistInSelectedOnes = indexParamInSelectedOnes !== -1 ? true : false;

                if (this.currentAction === 'modify') {
                    if (!paramExistInSelectedOnes) {
                        this.$set(param, 'added', false);
                    } else {
                        this.$set(param, 'added', true);
                        this.checkIfParamHasItsFrameDisabled(param);
                    }
                } else {
                    this.$set(param, 'isSelectable', true);
                    if (!paramExistInSelectedOnes) {
                        this.$set(param, 'added', false);
                    } else {
                        this.$set(param, 'added', true);
                    }
                }
                items.push(param);
            }
        } else {
            //me fijo si en la tabla de seleccionados hay algun parametro con este frame ID
            //si hay lo quito
            for (let b = 0; b < this.itemsAvailableSelectedParams.length; b++) {
                let paramSelected = this.itemsAvailableSelectedParams[b];

                if (paramSelected['frame_id'] == frameId) {
                    this.deleteParameters('parameter_selected', [paramSelected]);
                }
            }
        }

        this.itemsAvailableParams = items;
    }

    checkIfParamHasItsFrameDisabled(param) {
        let indexFrame = this.getIndexId(this.itemsFramesAdded, param['frame_id']);
        if (indexFrame !== -1) {
            let frameOfParam = this.itemsFramesAdded[indexFrame];

            if (this.ecuIsCurrentlyActive && frameOfParam['isSelectable'] == false) {
                this.$set(param, 'isSelectable', false);
            } else {
                this.$set(param, 'isSelectable', true);
            }
        }
    }

    checkIfParamIdExistInSelectedParams(id: number) {
        return getIndexFromList(this.itemsAvailableSelectedParams, 'variable_id', id)
    }

    getBadgeColor() {
        return getAlertColorByPriority();
    }

    checkAndAssignAvailableSelectedParams(allParametersFromAllFrames) {
        //recorro todos los parámetros de todas las frames
        for (let i = 0; i < allParametersFromAllFrames.length; i++) {
            let currentParam = allParametersFromAllFrames[i];
            let currentParamId = currentParam['id'];
            currentParam['variable_id'] = currentParamId;

            //me fijo si el parametro actual esta en la lista de 'parametros seleccionados'
            let indexParamInSelectedParamsList = this.checkIfParamIdExistInSelectedParams(currentParamId);

            //si el parametro no esta en la lista
            if (indexParamInSelectedParamsList == -1) {
                // console.log("currentParam: ", currentParamId, ' no existe en :', this.itemsAvailableSelectedParams);
                if (this.ecuIsCurrentlyActive) {
                    this.checkIfParamHasItsFrameDisabled(currentParam);
                }
                //lo agrego a la lista de seleccionados
                this.selectParameter(currentParam);

                //si hay parametros disponibles seleccionados
                if (this.itemsAvailableParams.length !== 0) {
                    //me fijo si el parametro actual está en la lista de "parametros disponibles"
                    let indexParamInSelectedOnes = this.getIndexId(this.itemsAvailableParams, currentParamId);
                    if (indexParamInSelectedOnes !== -1) {
                        //si está en esta lista, fue agregado previamente
                        //lo marco como seleccionado
                        this.$set(this.itemsAvailableParams[indexParamInSelectedOnes], 'added', true);
                    }
                }
            }
        }
    }

    parseToHexa(value) {
        return getHexadecimalValue(value);
    }

    checkIfCategoryHasAnyFrameAssigned(category) {
        let categoryId;
        let condition;
        if (category['category_id'] !== undefined) {
            categoryId = category['category_id'];
            if (this.itemsFramesAdded.find(a => a['category'] == Number(categoryId))) {
                return true;
            } else {
                return false;
            }
        } else {
            categoryId = Number(category['category']['id']);
            if (this.itemsFramesAdded.find(a => a['category_id'] == categoryId)) {
                return true;
            } else {
                return false;
            }
        }
    }

    checkIfFrameHasAnyParamAssigned(frame) {
        let frameId = frame['id'];
        return existItemInList(this.itemsAvailableSelectedParams, 'frame_id', frameId)
    }

    get getSelectedCategories() {
        let categories: any = [];
        for (let i = 0; i < this.itemsSelectedCategories.length; i++) {
            let item = this.itemsSelectedCategories[i];
            categories.push(item['category']);
        }

        if (categories.length !== 0) {
            return categories.sort(sortObjectByPropertyName('description'));
        } else {
            return categories;
        }
    }

    get getSelectedFrames() {
        let frames: any = [];
        for (let i = 0; i < this.itemsFramesAdded.length; i++) {
            let item = this.itemsFramesAdded[i];
            frames.push(item);
        }

        if (frames.length !== 0) {
            return frames.sort(sortObjectByPropertyName('description'));
        } else {
            return frames;
        }
    }

    addOrRemoveSelectedFrames(item) {
        this.framesAddedSelected = [];
        if (!item.added) {
            if (!this.checkIfIDExistsInArray(this.itemsFramesAdded, item.id)) {
                this.$set(item, 'added', true);
                this.$set(item, 'protocol_type', this.protocolSelected['name']);
                this.$set(item, 'alerts', {
                    count: 0,
                    messages: []
                });
                this.itemsFramesAdded.push(item);
                const indexOfitemAdded = this.itemsFramesAdded.indexOf(item);
                if (indexOfitemAdded !== -1) {
                    this.$set(this.itemsFramesAdded[indexOfitemAdded], 'added', true);
                }
                this.framesAddedSelected = [];
            }
        } else {
            this.deleteParameters('frames_selected', [item]);
        }
    }

    addOrRemoveAvailableSelectedParams(items) {
        //recorro los param. seleccionados
        for (let i = 0; i < items.length; i++) {
            let item = items[i];
            if (!item.added) {
                let indexParamInSelectedParamsList = this.checkIfParamIdExistInSelectedParams(item['id']);
                if (indexParamInSelectedParamsList == -1) {
                    this.$set(item, 'added', true);
                    const indexOfitemAdded = this.itemsAvailableSelectedParams.indexOf(item);
                    if (indexOfitemAdded !== -1) {
                        this.$set(this.itemsAvailableSelectedParams[indexOfitemAdded], 'added', true);
                        this.$set(this.itemsAvailableSelectedParams[indexOfitemAdded], 'variable_id', item['id']);
                    } else {
                        this.$set(item, 'isSelectable', true);
                    }

                    this.selectParameter(item);
                }
            } else {
                this.deleteParameters('parameter_selected', [item]);
            }
        }
        this.availableParamsSelected = [];
        this.selectedAvailableParams = [];
        this.getFramesByCategoryAndProtocol(null);
    }

    selectParameter(paramToAdd) {
        if (!paramToAdd['min']) {
            paramToAdd['min'] = null;
        }
        if (!paramToAdd['max']) {
            paramToAdd['max'] = null;
        }
        let indexParamInSelectedParamsList = this.checkIfParamIdExistInSelectedParams(paramToAdd['id']);

        if (indexParamInSelectedParamsList == -1) {
            this.$set(paramToAdd, 'added', true);
            this.itemsAvailableSelectedParams.push(paramToAdd);
        }
    }

    customSortTables(items: object[], sortBy: string[], sortDesc: boolean[]) {
        return tableSort(items, sortBy, sortDesc)
    }

    triggerActionButton() {
        if (this.step == 1) {
            this.previewFile();
        } else {
            this.createEcu();
            // this.generateFile();
        }
    }

    filterTooltipsMessages(messages, title?) {
        if (messages !== undefined) {
            let allMessages: any = [];
            for (let i = 0; i < messages.length; i++) {
                let msgItem = messages[i];
                allMessages.push('- ' + msgItem + '<br>');
            }
            return allMessages.toString().replace(/,/g, '');
        } else {
            return '';
        }
    }

    get getFramesAddedSelected() {
        for (let i = 0; i < this.framesAddedSelected.length; i++) {
            let item = this.framesAddedSelected[i];

            if (this.checkIfFrameHasAnyParamAssigned(item)) {
                this.removeIndexFromArray(this.framesAddedSelected, i);
            }
        }
        return this.framesAddedSelected;
    }

    get getItemsFramesAdded() {
        return this.itemsFramesAdded;
    }

    @Watch('getItemsCategoriesAdded')
    watchGetItemsCategoriesAdded(items) {
        for (let i = 0; i < this.categoriesSelected.length; i++) {
            let item = this.categoriesSelected[i];
            if (item['isSelectable'] == false) {
                this.$set(this.categoriesSelected, 'isSelectable', false);
                this.removeIndexFromArray(this.categoriesSelected, i);
            }
        }
    }

    get getItemsCategoriesAdded() {
        for (let i = 0; i < this.itemsSelectedCategories.length; i++) {
            let item = this.itemsSelectedCategories[i];

            if (!this.checkIfCategoryHasAnyFrameAssigned(item)) {
                this.$set(item, 'isSelectable', true);
            } else {
                this.$set(item, 'isSelectable', false);
            }

            if (this.ecuIsCurrentlyActive && !item['new_item']) {
                this.$set(item, 'isSelectable', false);
            }
        }
        return this.itemsSelectedCategories;
    }

    existsAlertsInArray(array) {
        let itemsWithAlerts = 0;
        if (array.length !== 0) {
            for (let i = 0; i < array.length; i++) {
                let item = array[i];
                if (item['alerts'] && item['alerts']['count'] && item['alerts']['count'] > 0) {
                    itemsWithAlerts = itemsWithAlerts + 1;
                }
            }

            if (itemsWithAlerts > 0) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    get enablePreviewButton() {
        if (this.privateDescription === '') {
            return false;
        }

        if (this.ecurdaddr === '') {
            return false;
        }

        if (this.ecuwraddr === '') {
            return false;
        }

        if (this.invertPolaritySelected == null) {
            return false;
        }

        if (this.dtcsInterpretationTypeSelected == null) {
            return false;
        }

        if (this.listenOnlyModeSelected == null) {
            return false;
        }

        if (this.protocolSelected == null) {
            return false;
        }

        if (this.itemsFramesAdded.length == 0) {
            return false;
        }

        if (this.getCategoriesSelected.length == 0) {
            return false;
        }

        if (this.existsAlertsInArray(this.getItemsCategoriesAdded)) {
            return false;
        }

        if (this.existsAlertsInArray(this.getItemsFramesAdded)) {
            return false;
        }

        if (!this.validParamsSelected) {
            return false;
        }

        return true;
    }

    previewFile() {
        if (this.currentAction === 'preview_patch') {
            this.step = 1;
            this.previewPatchEcu = false;
            this.currentAction = 'preview';
        }
        this.scrollToTopOfModal();
        this.getEcuPreviewData();

        setTimeout(() => {
            this.step = 2;
        }, 0);
    }

    scrollToTopOfModal() {
        $('.dialog-scroll').scrollTop(0);
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    createEcu() {
        this.pendingRequest = true;
        this.pendingLoadingDialog('Generando ECU...');
        this.getEcuData();
        let self = this;
        self.scrollToTopOfModal();
        NormsServices.postCreateEcu(this.ecuPostData)
            .then(response => {
                this.$_successLoadingDialog({
                    response: response,
                    alternative_msg: 'ECU creada correctamente'
                });
                    self.pendingRequest = false;
                    self.closeModal();
                    self.$emit('add-new-ecu', response['new_ecu']);
            })
            .catch(error => {
                self.handleErrorAction(error, 'No se pudo crear la ECU');
            });
    }

    patchEcu() {
        let self = this;
        this.pendingRequest = true;

        if (!self.confirmPatch) {
            //modificar directamente
            self.scrollToTopOfModal();
            this.pendingLoadingDialog('Modificando ECU...');
        }
        this.getEcuData();

        NormsServices.patchEcu(this.ecuPostData)
            .then(response => {
                if (self.confirmPatch) {
                    self.previewPatchEcu = true;
                    self.previewFile();
                    let changes = response['data']['changes'];
                    let previewData = {
                        categories: changes['categories'],
                        frames: changes['frames'],
                        parameters: {
                            key: 'parameters',
                            add: this.getParamsByIds(changes['parameters']['add']),
                            remove: this.getExcludedParamsById(changes['parameters']['remove']),
                            modify: this.getParamsByVariableId(changes['parameters']['modify']),
                            values: this.getParamsLength()
                        }
                    };
                    this.$set(previewData['categories'], 'key', 'categories');
                    this.$set(previewData['categories'], 'values', this.ecuPostData['categories'].length);
                    this.$set(previewData['frames'], 'key', 'frames');
                    this.$set(previewData['frames'], 'modify', []);
                    this.$set(previewData['frames'], 'values', this.ecuPostData['frames'].length);

                    self.ecuPreviewData = previewData;
                    self.scrollToTopOfModal();
                    self.confirmPatch = false;
                    self.pendingRequest = false;
                    // self.previewFile();
                } else {
                    self.scrollToTopOfModal();
                    self.handleSuccessAction(response.data)
                    self.pendingRequest = false;
                    self.$emit('modify-ecu', response['data']['updated_ecu']);
                    self.closeModal();
                }
            })
            .catch(error => {
                if (error && error['status'] !== 200) {
                    self.handleErrorAction(error, 'No se pudo modificar la ECU');
                }
            });
    }

    getEcuData() {
        this.ecuPostData = {
            ecu_definition: {
                description: this.privateDescription,
                public_description: this.publicDescription,
                ecu_read_address: Number(this.ecurdaddr),
                ecu_write_address: Number(this.ecuwraddr),
                invert_polarity:
                    this.invertPolaritySelected == null
                        ? null
                        : this.getBooleanValue(this.invertPolaritySelected['value']),
                dtc_interpretation_type:
                    this.dtcsInterpretationTypeSelected == null
                        ? null
                        : Number(this.dtcsInterpretationTypeSelected['id']),
                listen_only_mode:
                    this.listenOnlyModeSelected == null
                        ? null
                        : this.getBooleanValue(this.listenOnlyModeSelected['value'])
            },
            protocol: Number(this.protocolSelected['id']),
            categories: this.getCategoriesSelectedPost,
            frames: this.getFramesAndParameters(this.itemsFramesAdded, this.itemsAvailableSelectedParams)
        };

        if (this.currentAction === 'modify' || this.currentAction === 'preview_patch') {
            let confirmPatch = this.confirmPatch == true ? false : true;
            this.$set(this.ecuPostData, 'confirm_patch', confirmPatch);
            this.$set(this.ecuPostData, 'id', this.previewEcuFromListData['id']);
        }
    }

    get ecuIsCurrentlyActive() {
        if (this.ecuIsActiveInFiles !== 0) {
            return true;
        } else {
            return false;
        }
    }

    getEcuPreviewData() {
        let ecuDataToPreview = {};
        if (this.previewEcuFromList) {
            ecuDataToPreview = this.previewEcuFromListData;
            this.ecuIsActiveInFiles = ecuDataToPreview['active_files'].length;
        } else {
            ecuDataToPreview = {
                ecu_definition: {
                    description: this.privateDescription,
                    public_description: this.publicDescription,
                    ecu_read_address: Number(this.ecurdaddr),
                    ecu_write_address: Number(this.ecuwraddr),
                    invert_polarity:
                        this.invertPolaritySelected == null
                            ? null
                            : this.getBooleanValue(this.invertPolaritySelected['value']),
                    dtc_interpretation_type:
                        this.dtcsInterpretationTypeSelected == null
                            ? null
                            : this.dtcsInterpretationTypeSelected['value'],
                    listen_only_mode:
                        this.listenOnlyModeSelected == null
                            ? null
                            : this.getBooleanValue(this.listenOnlyModeSelected['value']),
                    protocol:
                        this.protocolSelected !== null
                            ? this.protocolSelected['name'] + ' - ' + this.protocolSelected['description']
                            : ''
                },
                categories: this.getCategoriesSelected,
                frames: this.getFramesAndParameters(this.itemsFramesAdded, this.itemsAvailableSelectedParams)
            };
        }
        this.ecuPreviewData = this.formatPreviewData(ecuDataToPreview);
    }

    get getProtocolForSessionFrameModal() {
        if (this.protocolSelected !== null) {
            this.protocolSelected['value'] = this.protocolSelected['name'];
            let indexMatchedProtocol = getIndexFromList(this.protocolTypes, 'value', this.protocolSelected['value']);
            let protocolType = this.protocolTypes[indexMatchedProtocol];
            protocolType['id'] = Number(protocolType['id']);
            return protocolType;
        } else {
            return [];
        }
    }

    getFramesAndParameters(frames, parameters) {
        for (let i = 0; i < frames.length; i++) {
            let frameId = frames[i]['id'];
            let matchedParametersByFrameId = parameters.filter(item => item['frame_id'] === frameId);
            for (let b = 0; b < matchedParametersByFrameId.length; b++) {
                if (matchedParametersByFrameId[b]['min'] === '') {
                    matchedParametersByFrameId[b]['min'] = null;
                }
                if (matchedParametersByFrameId[b]['max'] === '') {
                    matchedParametersByFrameId[b]['max'] = null;
                }
                if (matchedParametersByFrameId[b]['default'] === '') {
                    matchedParametersByFrameId[b]['default'] = null;
                }

                if (matchedParametersByFrameId[b]['variable_id'] !== undefined) {
                    matchedParametersByFrameId[b]['variable_id'] = matchedParametersByFrameId[b]['variable_id'];
                } else {
                    matchedParametersByFrameId[b]['variable_id'] = matchedParametersByFrameId[b]['id'];
                }
            }
            frames[i]['parameters'] = matchedParametersByFrameId;
        }
        return frames;
    }

    getBooleanValue(value) {
        if (value === 'true') {
            return true;
        } else if (value === 'false') {
            return false;
        } else {
            return null;
        }
    }

    prevStep() {
        this.step = 1;
        this.confirmPatch = true;
    }

    get getCategoriesSelected() {
        let selectedCategories: any = [];

        for (let i = 0; i < this.itemsSelectedCategories.length; i++) {
            let item = this.itemsSelectedCategories[i];
            selectedCategories.push({
                category_id: item['category']['id'], //id categoría
                keepalive: item['keepalive'], //pueden ser nulleables //si el id es -1 front manda null
                initialization: item['initialization'], //pueden ser nulleables //si el id es -1 front manda null
                finalization: item['finalization'] //pueden ser nulleables //si el id es -1 front manda null
            });
        }
        return selectedCategories;
    }

    get getCategoriesSelectedPost() {
        let selectedCategories: any = [];

        for (let i = 0; i < this.itemsSelectedCategories.length; i++) {
            let item = this.itemsSelectedCategories[i];
            selectedCategories.push({
                category_id: item['category']['id'], //id categoría
                keepalive: item['keepalive']['id'] !== -1 ? item['keepalive']['id'] : null, //pueden ser nulleables //si el id es -1 front manda null
                initialization: item['initialization']['id'] !== -1 ? item['initialization']['id'] : null, //pueden ser nulleables //si el id es -1 front manda null
                finalization: item['finalization']['id'] !== -1 ? item['finalization']['id'] : null //pueden ser nulleables //si el id es -1 front manda null
            });
        }
        return selectedCategories;
    }

    get getFramesSelected() {
        let selectedFrames: any = [];
        for (let i = 0; i < this.itemsFramesAdded.length; i++) {
            let item = this.itemsFramesAdded[i];
            selectedFrames.push(item['id']);
        }
        return selectedFrames;
    }

    validateMinValue(minValue, defaultValue, maxValue) {
        if (minValue === null || minValue === '') {
            return true;
        } else {
            if (minValue == null) {
                return false;
            } else {
                if (Number(minValue) < Number(maxValue)) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    createNewSessionFrame(action, type) {
        this.editSessionFrame = false;
        this.eventCreateSF = type;
        this.actionModalSessionFrame = action;
        this.visibilityModalCreateSessionFrame(true);
    }

    createNewProtocol() {
        this.currentAction = 'create';
        this.editingProtocol = false;
        this.visibilityModalCreateProtocol(true);
    }

    modifyProtocol() {
        this.loadingModifyProtocol = true;
        this.editingProtocol = true;

        let protocolId = this.protocolSelected['id'];
        let self = this;
        NormsServices.getProtocolDetail(protocolId)
            .then(response => {
                let protocolData = {};
                let protocolKey = self.protocolSelected['name'].toLowerCase();
                protocolData = response['protocol'][protocolKey];
                self.$set(protocolData, 'baudrate', response['protocol']['baudrate']);
                self.$set(protocolData, 'description', response['protocol']['description']);
                self.$set(protocolData, 'id', response['protocol']['id']);
                self.$set(protocolData, 'type', response['protocol']['type']);
                self.protocolPatchData = protocolData;
                self.loadingModifyProtocol = false;
                self.visibilityModalCreateProtocol(true);
            })
            .catch(error => {
                this.loadingModifyProtocol = false;
                //  this.pendingRequestParamFromFramesSelected = false;
                self.handleErrorAction(error, 'No se pudo modificar el protocolo');
            });
    }

    closeModalCreateSessionFrame() {
        this.visibilityModalCreateSessionFrame(false);
    }

    visibilityModalCreateSessionFrame(value) {
        this.visibleModalCreateSessionFrame = value;
    }

    validateMaxValue(minValue, defaultValue, maxValue) {
        if (minValue == null || minValue === '') {
            return true;
        } else {
            if (Number(maxValue) <= Number(minValue)) {
                return false;
            } else {
                return true;
            }
        }
    }

    validateDefaultValue(minValue, defaultValue, maxValue) {
        if (defaultValue == null) {
            return true;
        } else {
            if (minValue && maxValue) {
                if (Number(defaultValue) < Number(minValue) || Number(defaultValue) > Number(maxValue)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }
    }

    addNewProtocol(newProtocol) {
        let createdProtocol = {
            description: newProtocol['description'],
            id: newProtocol['id'],
            name: newProtocol['name'],
            namedescription: newProtocol['name'] + ' - ' + newProtocol['description']
        };
        this.protocolOptions.push(createdProtocol);
        this.protocolSelected = createdProtocol;
        this.protocolOptions = this.protocolOptions.sort(sortObjectByPropertyName('namedescription'));
    }

    modifyECU() {
        if (this.step == 1 && this.currentAction === 'modify') {
            this.patchEcu();
        } else if (this.step == 2 && this.currentAction === 'preview') {
            this.scrollToTopOfModal();
            this.prevStep();
            this.loadPatchData(this.previewEcuFromListData);
            this.currentAction = 'modify';
        } else if (this.step == 2 && this.currentAction === 'preview_patch') {
            this.patchEcu();
        }
    }

    modifyFrame(frame) {
        let self = this;
        this.$set(frame, 'isLoading', true);
        NormsServices.getFrameDetail(frame['id'])
            .then(response => {
                let frameData = {};
                let protocolKey = self.protocolSelected['name'].toLowerCase();
                frameData = response[protocolKey];

                self.$set(frameData, 'description', response['description']);
                self.$set(frameData, 'type', response['type']);
                self.$set(frameData, 'broadcasted', response['broadcasted']);
                self.$set(frameData, 'updatedperiodically', response['updatedperiodically']);
                self.$set(frameData, 'updatedonetime', response['updatedonetime']);
                self.$set(frameData, 'updatedonrequest', response['updatedonrequest']);
                self.$set(frameData, 'period', response['period']);
                self.$set(frameData, 'validitytime', response['validitytime']);
                self.$set(frameData, 'framelength', response['framelength']);
                self.$set(frameData, 'framearray', response['framearray']);
                self.$set(frameData, 'category', response['category']);
                self.$set(frameData, 'protocol_type', response['protocol_type']);
                self.$set(frameData, 'id', frame['id']);
                self.$set(frameData, 'parameter_list', response['parameter_list']);
                self.$set(frameData, 'ecu_count', response['ecu_count']);

                self.frameToPatch = frameData;
                self.editingFrame = true;
                self.$set(frame, 'isLoading', false);
                self.visibilityModalCreateFrame(true);
            })
            .catch(error => {
                self.$set(frame, 'isLoading', false);
                self.handleErrorAction(error, 'No se pudo obtener el detalle de la frame');
            });
    }

    addNewSessionFrame(newSessionFrame) {
        let newItem = {
            description: newSessionFrame['description'],
            id: newSessionFrame['id']
        };
        this.sessionFramesOptions.push(newItem);

        if (this.eventCreateSF === 'keep_alive') {
            this.updateKeepAliveSelected(newItem);
        } else if (this.eventCreateSF === 'init') {
            this.updateInitializationSelected(newItem);
        } else if (this.eventCreateSF === 'fin') {
            this.updateFinalizationSelected(newItem);
        }
    }

    modifySessionFrame(action, type) {
        this.eventCreateSF = type;
        let sessionFrameId;
        //modifySessionFrameData
        if (this.eventCreateSF === 'keep_alive') {
            this.loadingPatchKeepAlive = true;
            sessionFrameId = this.keepAliveSelected['id'];
        } else if (this.eventCreateSF === 'init') {
            this.loadingPatchInit = true;
            sessionFrameId = this.initializationSelected['id'];
        } else if (this.eventCreateSF === 'fin') {
            this.loadingPatchFin = true;
            sessionFrameId = this.finalizationSelected['id'];
        }

        let self = this;
        self.modifySessionFrameData = {};
        NormsServices.getSessionFrameById(sessionFrameId)
            .then(response => {
                self.actionModalSessionFrame = action;
                if(response['framearray'] === '{}'){
                    response['framearray'] = ''
                }
                self.stopLoadingSessionFrameGetDetail();
                self.editSessionFrame = true;
                self.modifySessionFrameData = response;
                self.visibilityModalCreateSessionFrame(true);
            })
            .catch(error => {
                // console.log("error", error);
                self.stopLoadingSessionFrameGetDetail();
                self.handleErrorAction(error, 'No se pudo obtener la session frame by id');
            });
    }

    stopLoadingSessionFrameGetDetail() {
        if (this.eventCreateSF === 'keep_alive') {
            this.loadingPatchKeepAlive = false;
        } else if (this.eventCreateSF === 'init') {
            this.loadingPatchInit = false;
        } else if (this.eventCreateSF === 'fin') {
            this.loadingPatchFin = false;
        }
    }

    validateForm() {
        this.form.validate();
    }

    get form(): Vue & { validate: () => boolean } {
        return this.$refs.formParamsSelected as Vue & { validate: () => boolean };
    }

    get getModalTitle() {
        if (this.step == 1) {
            if (!this.previewEcuFromList) {
                return this.titleCreate;
            } else {
                return this.titleModify;
            }
        } else {
            if (this.currentAction === 'preview_patch') {
                return this.titlePreviewPatch;
            } else {
                return this.titlePreviewECU;
            }
        }
    }

    disabledExcludeCategories(item) {
        if (this.checkIfCategoryHasAnyFrameAssigned(item)) {
            return true;
        } else {
            return false;
        }
    }

    disabledExcludeFrames(item) {
        if (this.checkIfFrameHasAnyParamAssigned(item)) {
            this.$set(item, 'isSelectable', false);
            return true;
        } else {
            this.$set(item, 'isSelectable', true);
            return false;
        }
    }

    addNewFrame(newFrame) {
        //"category_id":
        let categoryId = newFrame['category_id'];
        let frameId = newFrame['id'];
        let categoryToAdd = this.getIndexId(this.categoriesOptions, categoryId);

        this.addCategoryToSelectedOnes({
            id: categoryId,
            protocol_type: this.protocolSelected['name'],
            category: this.categoriesOptions[categoryToAdd],
            keepalive: this.noAvailableObject,
            initialization: this.noAvailableObject,
            finalization: this.noAvailableObject,
            alerts: this.defaultAlert
        });

        this.$set(newFrame, 'added', false);

        newFrame = {
            id: frameId,
            description: newFrame['description'],
            type: newFrame['type'],
            category_id: categoryId,
            category_descripcion: this.categoriesOptions[categoryToAdd]['description'],
            added: false,
            protocol_type: this.protocolSelected['name'],
            alerts: this.defaultAlert
        };

        this.updateCategoryInAssignFrames(this.categoriesOptions[categoryToAdd], newFrame);
    }

    visibilityModalCreateFrame(value) {
        this.visibleModalCreateFrame = value;
        this.handleListenKey(false);
    }

    closeModalCreateFrame() {
        this.visibilityModalCreateFrame(false);
    }

    showCloseConfirmationModal() {
        this.visibilityCloseConfirmationModal(true);
    }

    visibilityCloseConfirmationModal(value) {
        this.visibleCloseConfirmationModal = value;
    }
}
